import getStore from './getStore';
import { addError } from '../components/Notifications/actions';

export default function attachErrorListener() {
  window.addEventListener('error', () => {
    const message = 'Något har gått fel. Felet har rapporterats till våra tekniker.';
    getStore().dispatch(addError({ message }));
  });
}

